import * as React from 'react'
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import Page from 'components/common/layout/Page'
import Container from 'components/common/layout/Container'

import { fetchRequest } from 'store/teacher/actions'
import { translations } from 'i18n/rus'
import { StyledButton, StyledLink, PanelGrid, StyledH2 } from 'components/common'
import { Grid } from '@material-ui/core'

import { DetailsDialog } from 'components/schedule/dialog/DetailsDialog'
import { selectTeacherIndexPageState } from 'store/teacher/selectors'
import TeacherSchedulePanel from 'components/teacher/schedulePanel/teacher'
import { PageUrls } from 'utils/constants'
import { Loading } from 'components/common/data/Loading'

const TeacherIndexPage: React.FC = () => {
  const dispatch = useDispatch()
  const { loading, data } = useSelector(selectTeacherIndexPageState)

  useEffect(() => {
    dispatch(fetchRequest())
  }, [dispatch])

  return (
    <Page>
      <Container>
        <Grid alignItems="center" direction="column" container>
          <StyledLink tabIndex={-1} to={PageUrls.TeacherPastLessons}>
            <StyledButton>{translations.pastLessonsButton}</StyledButton>
          </StyledLink>
          <StyledH2>{translations.mySchedule}</StyledH2>
          {loading && <Loading />}
          {
            <PanelGrid>
              <TeacherSchedulePanel subjectsById={data.subjectsById} lessons={data.lessons} teacherById={data.teachersById} />
              <DetailsDialog />
            </PanelGrid>
          }
        </Grid>
      </Container>
    </Page>
  )
}

export default TeacherIndexPage
